export const CA_DOCUMENT_TYPE_VALUES = {
  // Parent
  FUEL_BILL: 'fuel_bill',
  ELECTRICITY_BILLS: '66e956203def64db6dd9b761',
  PROCUREMENT_BILLS: 'procurement_bills',
  SERVICE_BILLS: 'service_bills',
  BUSINESS_TRAVEL_TICKETS: 'business_travel_tickets',
  WATER_BILLS: 'water_bills',

  // Fuel Bill Children
  FOR_MACHINES: 'for_machines',
  FOR_VEHICLE: 'for_vehicle',
  FOR_REFRIGERANT: 'for_refrigerant',

  // Electricity Children
  RENEWABLE: 'renewable',
  NON_RENEWABLE: 'non_renewable',

  // Procurement
  FOR_RAW_MATERIAL: 'for_raw_material',
  RAW_MATERIAL_AVERAGE: 'row_material_average',
  RAW_MATERIAL_SUPPLIER_SPECIFIC: 'row_material_supplier_specific',

  FOR_CAPITAL_GOODS: 'for_capital_goods',
  CAPITAL_GOOD_AVERAGE: 'capital_good_average',
  CAPITAL_GOOD_SUPPLIER_SPECIFIC: 'capital_good_supplier_specific',

  // Service
  UPSTREAM_TRANSPORT: 'upstream_transport',
  DOWNSTREAM_TRANSPORT: 'downstream_transport'
} as const;

export type CADocumentTypeValue =
  (typeof CA_DOCUMENT_TYPE_VALUES)[keyof typeof CA_DOCUMENT_TYPE_VALUES];

/* eslint-disable @typescript-eslint/no-loss-of-precision */
export const CADocumentTypeOptions = [
  {
    label: 'Fuel Bill',
    value: CA_DOCUMENT_TYPE_VALUES.FUEL_BILL,
    hidden: true,
    children: [
      {
        label: 'For Machines',
        value: CA_DOCUMENT_TYPE_VALUES.FOR_MACHINES,
        hidden: false
      },
      {
        label: 'For Vehicle',
        value: CA_DOCUMENT_TYPE_VALUES.FOR_VEHICLE,
        hidden: false
      },
      {
        label: 'For Refrigerant',
        value: CA_DOCUMENT_TYPE_VALUES.FOR_REFRIGERANT,
        hidden: false
      }
    ]
  },
  {
    label: 'Electricity Bills',
    value: CA_DOCUMENT_TYPE_VALUES.ELECTRICITY_BILLS,
    hidden: false,
    children: [
      {
        label: 'Renewable',
        value: CA_DOCUMENT_TYPE_VALUES.RENEWABLE,
        hidden: true
      },
      {
        label: 'Non Renewable',
        value: CA_DOCUMENT_TYPE_VALUES.NON_RENEWABLE,
        hidden: false
      }
    ]
  },
  {
    label: 'Procurement Bills',
    value: CA_DOCUMENT_TYPE_VALUES.PROCUREMENT_BILLS,
    hidden: true,
    children: [
      {
        label: 'For Raw Material',
        value: CA_DOCUMENT_TYPE_VALUES.FOR_RAW_MATERIAL,
        hidden: false,
        children: [
          {
            label: 'Average',
            value: CA_DOCUMENT_TYPE_VALUES.RAW_MATERIAL_AVERAGE,
            hidden: false
          },
          {
            label: 'Supplier Specific',
            value: CA_DOCUMENT_TYPE_VALUES.RAW_MATERIAL_SUPPLIER_SPECIFIC,
            hidden: false
          }
        ]
      },
      {
        label: 'For Capital Goods',
        value: CA_DOCUMENT_TYPE_VALUES.FOR_CAPITAL_GOODS,
        hidden: false,
        children: [
          {
            label: 'Average',
            value: CA_DOCUMENT_TYPE_VALUES.CAPITAL_GOOD_AVERAGE,
            hidden: false
          },
          {
            label: 'Supplier Specific',
            value: CA_DOCUMENT_TYPE_VALUES.CAPITAL_GOOD_SUPPLIER_SPECIFIC,
            hidden: false
          }
        ]
      }
    ]
  },
  {
    label: 'Service Bills',
    value: CA_DOCUMENT_TYPE_VALUES.SERVICE_BILLS,
    hidden: true,
    children: [
      {
        label: 'Upstream Transport',
        value: CA_DOCUMENT_TYPE_VALUES.UPSTREAM_TRANSPORT,
        hidden: false
      },
      {
        label: 'Downstream Transport',
        value: CA_DOCUMENT_TYPE_VALUES.DOWNSTREAM_TRANSPORT,
        hidden: false
      }
    ]
  },
  {
    label: 'Business Travel Tickets',
    value: CA_DOCUMENT_TYPE_VALUES.BUSINESS_TRAVEL_TICKETS,
    hidden: true
  },
  {
    label: 'Water Bills',
    value: CA_DOCUMENT_TYPE_VALUES.WATER_BILLS,
    hidden: true
  }
];

export const PollingDBStatus = {
  ready_for_review: 'ready_for_review',
  uploaded: 'uploaded',
  failed: 'failed',
  in_progress: 'in_progress'
};

export const PollingStatusMessages = {
  processingFailed: 'Processing Failed, Please Re-Upload file and try again!'
};

export const StepState = {
  NORMAL: 'NORMAL',
  UPLOAD_AND_VALIDATE: 'UPLOAD_AND_VALIDATE',
  WITH_FILE_PREVIEW: 'WITH_FILE_PREVIEW'
};
